.textAreaContainer {
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .textArea {
    padding: 12px;
    width: 100%;
    box-sizing: border-box;
    font-family:
      Galano Grotesque,
      Segoe UI,
      sans-serif;
  }

  .validIcon {
    top: 8px;
    right: 8px;
  }

  .noBorder {
    border: none;
  }

  * {
    resize: none;
  }
}
